import { type GridColDef, type GridValidRowModel } from '@/ui/primitives';

type GridCellValue = string | number | boolean | Date | null | undefined;
type SelectOption = string | number | { label?: string; value?: string | number };

type BaseColumnOptions<T extends GridValidRowModel> = {
  field: keyof T & string;
  headerName: string;
  flex?: number;
};

const getFormatterValue = (params?: { value?: GridCellValue | null } | null): GridCellValue =>
  params ? (params.value as GridCellValue) : undefined;

export const getSingleSelectOptionLabel = (option: SelectOption): string => {
  if (typeof option === 'string' || typeof option === 'number') return String(option);
  const label = option.label;
  if (typeof label === 'string') return label;
  const value = option.value;
  return typeof value === 'string' ? value : '';
};

export const getSingleSelectOptionValue = (option: SelectOption): string => {
  if (typeof option === 'string' || typeof option === 'number') return String(option);
  const value = option.value;
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  return '';
};

export const numberColumn = <T extends GridValidRowModel>(
  options: BaseColumnOptions<T> & { formatter?: (value: number | null | undefined) => string },
): GridColDef<T> => ({
  ...options,
  flex: options.flex ?? 1,
  type: 'number',
  align: 'right',
  headerAlign: 'right',
  valueFormatter: (params) => {
    const value = getFormatterValue(params);
    const formatted = options.formatter?.(value as number | undefined);
    if (typeof formatted === 'string') return formatted;
    if (value === null || value === undefined) return '';
    if (typeof value === 'number') return String(value);
    return '';
  },
});
